import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const TONES = {
  indigo: 'bg-brand-50 text-brand-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  amber: 'bg-amber-50 text-amber-600',
  rose: 'bg-rose-50 text-rose-600',
  sky: 'bg-sky-50 text-sky-600',
  slate: 'bg-slate-100 text-slate-600',
};

// KPI tile. trend: { dir: 'up'|'down'|'flat', text, positive: bool }
export default function Stat({ label, value, sub, icon: Icon, tone = 'indigo', trend, onClick }) {
  const TrendIcon = trend?.dir === 'up' ? TrendingUp : trend?.dir === 'down' ? TrendingDown : Minus;
  return (
    <div className={`dh-card p-4 ${onClick ? 'lift cursor-pointer' : ''}`} onClick={onClick}>
      <div className="flex items-center justify-between">
        <div className="text-xs text-slate-500">{label}</div>
        {Icon && <div className={`h-7 w-7 rounded-lg flex items-center justify-center ${TONES[tone]}`}><Icon className="h-4 w-4" /></div>}
      </div>
      <div className="mt-2 text-2xl font-semibold text-slate-900 tnum tracking-tight">{value}</div>
      <div className="mt-1 flex items-center gap-2 text-xs">
        {sub && <span className="text-slate-500">{sub}</span>}
        {trend && (
          <span className={`inline-flex items-center gap-0.5 font-medium ${trend.positive ? 'text-emerald-600' : 'text-rose-600'}`}>
            <TrendIcon className="h-3 w-3" />{trend.text}
          </span>
        )}
      </div>
    </div>
  );
}
